import { useMemo } from 'react';

import { useLocation } from 'react-router';

import { useProcessedImageUrl } from 'src/app/shared/hooks/image';
import { useCurrentUser } from 'src/app/shared/hooks/session';
import { isLoaded } from 'src/app/shared/utils/async';

import { useFcm } from '../../../../../../../shared/fcm';
import { logoutUrl } from '../../../../../../../shared/navigation';
import { useHeaderNavLinks } from '../../../../../../shared/hooks';
import type { HeaderNavLink } from '../../../../../../shared/hooks';

type Result = ModelHookResult<{
	atLeastIdentified: boolean;
	avatarUrl: string;
	userName: string;
	logoutUrl: string;
	navLinks: readonly HeaderNavLink[];
}>;

const DEFAULT_AVATAR = 'https://static.change.org/profile-img/default-user-profile.svg';

export function useDropdown({ mobile }: { mobile: boolean }): Result {
	const currentUser = useCurrentUser();
	const fcmState = useFcm();
	const location = useLocation();

	const navLinks = useHeaderNavLinks();

	const userAvatarUrl = useProcessedImageUrl(currentUser?.photo?.userMedium);
	const isMembershipEnabled = isLoaded(fcmState) && fcmState.values.membershipEnabled;

	return {
		data: {
			atLeastIdentified: !!currentUser,
			avatarUrl: userAvatarUrl || DEFAULT_AVATAR,
			userName: currentUser?.displayName || '',
			logoutUrl: logoutUrl({ redirectTo: location }),
			navLinks: useMemo(
				() => [
					...(mobile ? [navLinks.startAPetition] : []),
					navLinks.myPetitions,
					...(mobile && isMembershipEnabled ? [navLinks.membership] : []),
					...(mobile ? [navLinks.browse] : []),
					...(mobile ? [navLinks.search] : []),
					...(currentUser ? [navLinks.settings] : []),
				],
				[navLinks, isMembershipEnabled, currentUser, mobile],
			),
		},
	};
}
